import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../components/Layout/Layout';
import Hero from '../components/Screens/Hero';

// ====

const Document = (props) => {
  const { pageContext, blok } = props;
  let doc;
  if (pageContext) {
    doc = JSON.parse(pageContext.story.content);
  } else {
    doc = blok;
  }
  const openGraph = {
    type: 'website',
    title: doc.title,
    description: doc.body,
    image: doc.image,
  };

  return (
    <Layout meta={doc.meta} openGraph={openGraph}>
      <Hero
        title={doc.title}
        copy={doc.body}
        image={doc.image}
        backgroundColor={doc.background_color.color}
      />
    </Layout>
  );
};

export default Document;

Document.propTypes = {
  pageContext: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  blok: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Document.defaultProps = {
  pageContext: null,
  blok: null,
};
